import type { ReactNode } from 'react';

export const symbol_dual_screen: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m220-242 280 112v-588L220-830v588Zm-22 55q-17-7-27.5-21.5T160-242v-578q0-24.75 17.63-42.38Q195.25-880 220-880l300 106q18 6 29 21.53 11 15.53 11 34.47v588q0 32.01-26.5 49.51Q507-63 478-75L198-187Zm302-13v-60h240v-560H220v-60h520q24.75 0 42.38 17.62Q800-844.75 800-820v560q0 24.75-17.62 42.37Q764.75-200 740-200H500Zm-280-42v-588 588Z"
		/>
	</svg>
);
